module.exports = __webpack_public_path__ + "static/img/loader.fb0cd48.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bel9850/loader.gif
// module id = kXwN
// module chunks = 0